import { Modal, ModalHeader, ModalContent, ModalFooter } from './Modal';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

export { Modal, ModalContent, ModalFooter, ModalHeader } from './Modal';

@NgModule({
  imports: [CommonModule],
  declarations: [
    Modal,
    ModalHeader,
    ModalContent,
    ModalFooter,
  ],
  exports: [
    Modal,
    ModalHeader,
    ModalContent,
    ModalFooter,
  ],
})
export class ModalModule {

}
